module.exports = __webpack_public_path__ + "static/img/sw_qw_2.0e5091f9.png";